export const ourCapabilities = [
  "Customised Electronics Solutions",
  "Complete Product Manufacturing",
  "3D data capture and designing",
  "CFD and FEA Analysis",
  "Customised AI-based Software Solutions",
];
